import React, { useContext, useEffect, useState } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, Typography, LinearProgress } from '@material-ui/core';
import { makeStyles } from "@material-ui/styles";
import DialogContent from '@material-ui/core/DialogContent';
import * as actions from "../actions/actions";
import ReactMarkdown from 'react-markdown';
import YoutubeEmbed from "./YoutubeEmbed";

const useStyles = makeStyles((theme) => ({
  popupButton: {
    justifyContent: "center"
  },
}));

export default function ConfirmationDialog() {
  const state = useContext(AppContext);
  const s = state.strings;
  const dispatch = useContext(DispatchContext);
  const classes = useStyles();
  const [confirmed, setConfirmed] = useState(false);

  const { onConfirm, onCancel, payload, title, text, markdown, embedId, visible, waitingMessage, okLabel, cancelLabel, hideCancelLabel } = state.ui.logDialog;

  useEffect(() => {
    setConfirmed(false);
  }, [state.ui.confirmationDialog.visible]);


  const handleConfirm = () => {
    if (!waitingMessage) {
      dispatch(actions.closeLogDialog());
    }
    setConfirmed(true);
    onConfirm && onConfirm(payload);
  }

  const handleCancel = () => {
    dispatch(actions.closeLogDialog());
    onCancel && onCancel(payload);
  }

  return (
    <Dialog fullWidth={true} maxWidth="md" scroll="Paper" onClose={handleCancel} open={visible} disableBackdropClick={hideCancelLabel}>
      <DialogTitle >
        {title}
      </DialogTitle>
      <DialogContent dividers style={{ padding: embedId ? 0 : 16 }}>
        {text && 
          <ul>
          {text && text.map((line) => {return <li><Typography>{line}</Typography></li>})}
          </ul>
        }
        {markdown && 
          <ReactMarkdown>{markdown}</ReactMarkdown>
        }
        {embedId && 
          <YoutubeEmbed embedId={embedId} />
        }

      </DialogContent>
      <DialogActions className={classes.popupButton} >
        {onConfirm && <Button disabled={confirmed} variant="contained" color="primary" onClick={handleConfirm}>
          {okLabel ? okLabel : s.yes}
        </Button>}
        {!hideCancelLabel && 
            <Button disabled={confirmed} variant="outlined" color="primary" onClick={handleCancel}>
              {cancelLabel ? cancelLabel : onConfirm ? s.common.no : s.common.ok}
            </Button>
        }
      </DialogActions>
    </Dialog>
  )
}